/* eslint-disable jsx-a11y/click-events-have-key-events */
import moment from "moment";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FormattedMessage, useIntl } from "react-intl";

import "react-datepicker/dist/react-datepicker.css";
import { DateFilterTypes } from "constants/";

type DateFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
};

function DateFilter(props: DateFilterProps) {
  const Intl = useIntl();
  const { currentFilters, setFilters, filterKey } = props;
  const selectedDateType = currentFilters[filterKey]?.type;

  const handlePresetSelect = (type: string | number) => {
    const removedDates = {
      startDate: null,
      endDate: null,
    };
    if (currentFilters[filterKey]?.type === type) {
      setFilters({
        ...currentFilters,
        [filterKey]: undefined,
      });
    } else {
      setFilters({
        ...currentFilters,
        [filterKey]: {
          ...currentFilters[filterKey],
          ...removedDates,
          type,
        },
      });
    }
  };

  const handleDateSelect = (date: Date | null, key: string) => {
    const updatedState = {
      [filterKey]: {
        ...currentFilters[filterKey],
        [key]: date,
      },
    };
    if (!updatedState[filterKey].startDate && !updatedState[filterKey].endDate) {
      setFilters({
        ...currentFilters,
        [filterKey]: undefined,
      });
    } else {
      setFilters({
        ...currentFilters,
        [filterKey]: {
          ...updatedState[filterKey],
          type: DateFilterTypes.CUSTOM,
        },
      });
    }
  };

  return (
    <div className="date-filter">
      <div className="d-flex justify-content-around align-items-center mb-8">
        <Button
          variant="outline-primary"
          className={`rounded-pill date-filter-btn ${selectedDateType === DateFilterTypes.LAST_MONTH ? "active" : ""}`}
          onClick={() => handlePresetSelect(DateFilterTypes.LAST_MONTH)}
        >
          <FormattedMessage id="report.lastMonth" defaultMessage="Last month" />
        </Button>
        <Button
          variant="outline-primary"
          className={`rounded-pill date-filter-btn ${selectedDateType === DateFilterTypes.LAST_WEEK ? "active" : ""}`}
          onClick={() => handlePresetSelect(DateFilterTypes.LAST_WEEK)}
        >
          <FormattedMessage id="report.lastWeek" defaultMessage="Last week" />
        </Button>
      </div>
      <div className="d-flex justify-content-around align-items-center mb-3">
        <Button
          variant="outline-primary"
          className={`rounded-pill date-filter-btn ${selectedDateType === DateFilterTypes.YESTERDAY ? "active" : ""}`}
          onClick={() => handlePresetSelect(DateFilterTypes.YESTERDAY)}
        >
          <FormattedMessage id="general.yesterday" defaultMessage="Yesterday" />
        </Button>
        <Button
          variant="outline-primary"
          className={`rounded-pill date-filter-btn ${selectedDateType === DateFilterTypes.TODAY ? "active" : ""}`}
          onClick={() => handlePresetSelect(DateFilterTypes.TODAY)}
        >
          <FormattedMessage id="general.today" defaultMessage="Today" />
        </Button>
      </div>
      <div className="d-flex align-items-center ml-2" onClick={(e) => e.stopPropagation()}>
        <div className="mr-4">
          <p className="text-primary mb-2">
            <FormattedMessage id="general.from" defaultMessage="From" />
          </p>
          <div className="picker-container">
            <DatePicker
              className="picker"
              selected={currentFilters[filterKey]?.startDate ? moment(currentFilters[filterKey]?.startDate).toDate() : null}
              onChange={(date) => handleDateSelect(date, "startDate")}
              placeholderText={Intl.formatMessage({
                id: "settings.notifications.selectDate",
                defaultMessage: "Select date",
              })}
            />
          </div>
        </div>
        <div>
          <p className="text-primary mb-2">
            <FormattedMessage id="general.to" defaultMessage="To" />
          </p>
          <div className="picker-container">
            <DatePicker
              className="picker"
              selected={currentFilters[filterKey]?.endDate ? moment(currentFilters[filterKey]?.endDate).toDate() : null}
              onChange={(date) => handleDateSelect(date, "endDate")}
              placeholderText={Intl.formatMessage({
                id: "settings.notifications.selectDate",
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DateFilter;
